"use strict";

var tagBody = "(?:[^\"'>]|\"[^\"]*\"|'[^']*')*";

var tagOrComment = new RegExp("<(?:" +
// Comment body.
"!--(?:(?:-*[^->])*--+|-?)" +
// Special "raw text" elements whose content should be elided.
"|script\\b" + tagBody + ">[\\s\\S]*?</script\\s*" + "|style\\b" + tagBody + ">[\\s\\S]*?</style\\s*" +
// Regular name
"|/?[a-z]" + tagBody + ")>", "gi");

function removeTags(html) {
  var oldHtml;
  do {
    oldHtml = html;
    html = html.replace(tagOrComment, "");
  } while (html !== oldHtml);
  return html.replace(/</g, "&lt;");
}

var id = 0;
var reports = [];
var url;

var responses;
var addresses;
var j;
var current_report_index;
var recent_url;
var live;
var decodedText;
var insecure_links;

getID();

function getID() {
  var q = window.location.pathname;
  id = q.slice(q.indexOf("t/") + 2);
}

$.ajax({
  type: "POST",
  url: "/api/getreportbyid",
  data: {
    id: id
  },
  dataType: "JSON",
  timeout: 4500,
  success: callback,
  error: fail
});

function callback(data) {
  var gid = data.group_id;
  $.ajax({
    type: "POST",
    url: "/api/getgroup",
    data: {
      group_id: gid
    },
    dataType: "JSON",
    timeout: 4500,
    success: function success(res) {
      for (var i = 0; i < res.rowCount; i++) {
        if (data.ip_address !== res.rows[i].ip_address) {
          reports.push({
            report: res.rows[i].report_id,
            ip: res.rows[i].ip_address
          });
        }
      }
    }
  }).done(function () {
    var cert = JSON.parse(data.cert);

    addReport(data.ip_address, data.report_id, "active");
    for (var i = 0; i < reports.length; i++) {
      addReport(reports[i].ip, reports[i].report, "");
    }
    if (Object.keys(cert).length < 3) {
      //$('#scanner').slideUp();
      $("#timeout").slideDown();
    } else {
      //if(data.cert !== undefined)
      formatReport(JSON.parse(data.cert));
    }
  });
}

function fail(request, status, err) {
  console.log(err);
}

function prepareReports() {
  $("#servers").html("");
  addReport();
  $("#report").slideDown();
  $("#1").click();
}

function addReport() {
  var i = responses.length - 1;
  $("#servers").append('<li class="report_button" id="' + i + '"><a>' + addresses[j] + "</a></li>");
}

function addReport(ip, id, active) {
  //var i = responses.length - 1;
  $("#servers").append('<li class="report_button ' + active + '"><a href="/report/' + id + '">' + ip + "</a></li>");
}

function formatReport(data) {
  //console.log(data);
  // Clear up wildcard from url
  if (data.url.indexOf("%") == 0) {
    data.url = data.url.substring(1);
  }
  var nameSite = data.url;
  $("#siteName").html(removeTags(nameSite.toUpperCase()));
  //Update URL input field
  //$("#url").val(data.url);

  //Scan time and duration
  if (data.live == undefined) {
    $("#scan_time").html("Scan completed on " + data.scan_time + " after " + data.scan_duration + " seconds. <b>[CACHED COPY]</b>");
  } else {
    $("#scan_time").html("Scan completed on " + data.scan_time + " after " + data.scan_duration + " seconds. ");
  }

  //Add link to scan site
  $("#site_link").attr("target", "_blank");
  $("#site_link").attr("href", "https://" + data.url);
  $("#site_link").html("https://" + data.url + " <span class='glyphicon glyphicon-new-window'></span>");

  //Subject Info
  $("#common_name").text(removeTags(data.subject.CN || "N/A"));
  $("#organization").text(removeTags(data.subject.O || "N/A"));
  $("#locality").text(removeTags(data.subject.L || "N/A"));
  $("#state").text(removeTags(data.subject.ST || "N/A"));
  $("#country").text(removeTags(data.subject.C || "N/A"));
  $("#ip_address").text(removeTags(data.ip_address || "N/A"));
  $("#server_signature").text(removeTags(data.server || "N/A"));

  //SAN Entries
  var cert_name_match = false;
  try {
    var san_string = "";
    var san = data.san_entries;

    var san_links = [];
    for (var i = 0; i < san.length; i++) {
      if (san[i].indexOf("%") == 0) {
        var t = san[i].substring(1);
        san_links[i] = t;
        san[i] = "*." + t;
      } else {
        san_links[i] = san[i];
      }
    }
    for (var i = 0; i < san.length; i++) {
      san_string += '<a href="/?url=' + san_links[i] + '">' + san[i] + "</a>, ";
    }
    san_string = san_string.substring(0, san_string.length - 2) + ".";

    //check for certificate name mismatch
    for (var i = 0; i < san.length; i++) {
      if (data.url.match(new RegExp("^" + san[i].replace("*.", "(.*\\.+)*") + "$", "i"))) {
        cert_name_match = true;
        continue;
      }
    }
    if (!cert_name_match) {
      san_string += '<hr /><div class="alert alert-danger" role="alert"><strong><span class="glyphicon glyphicon-warning-sign" aria-hidden="true"></span> Certificate Name Mismatch! </strong> ' + data.url + " is not a SAN entry.</div>";
    }

    $("#san_entries").html(removeTags(san_string));
  } catch (e) {
    $("#san_entries").html("");
  }

  //Cert Type
  var glyph_class = data.cert_type == "EV" ? "glyphicon-star-empty" : data.cert_type == "OV" ? "glyphicon-ok" : "glyphicon-exclamation-sign";
  $("#cert_type_glyph").removeClass();
  $("#cert_type_glyph").addClass("glyphicon " + glyph_class);
  $("#cert_type_text").text(removeTags(data.cert_type));

  //Certificate Chain
  var chain = "";
  var cert = data;
  var root_cert = data;
  var i = 0;
  while (cert) {
    //add arrow (if not server)
    if (cert != data) chain += '<div class="row arrow"><h1><span class="glyphicon glyphicon-arrow-down" aria-hidden="true"></span></h1></div>';
    //cert name and type (server / intermediate / root)
    chain += '<div class="row center"><div class="col-sm-6"><h1>' + removeTags(cert.subject.O || cert.subject.CN) + "</h1><h3>";
    chain += cert == data ? "Server Certificate" : cert.issuerCertificate ? "Intermediate Certificate" : "Root Certificate";
    chain += '</h3><div class="btn-group" role="group" aria-label="Download/View Certificate"><button type="button" class="btn btn-primary" data-toggle="modal" data-target="#certModal" data-level="' + i + '">&nbsp;View Details&nbsp;</button><a type="button" class="btn btn-primary" href="/api/download?type=crt&id=' + cert.id + '">Download (PEM)</a><a type="button" class="btn btn-primary" href="/api/download?type=der&id=' + cert.id + '">Download (DER)</a></div></div><div class="col-sm-6">';
    //cert attributes
    chain += '<div class="row left"><b><div class="col-xs-4">Common Name: </div><div class="col-xs-8">' + removeTags(cert.subject.CN || "N/A") + "</div></b></div>";
    chain += '<div class="row left"><div class="col-xs-4">Location: </div><div class="col-xs-8">' + removeTags(cert.subject.C || "N/A") + "</div></div>";
    chain += '<div class="row left"><div class="col-xs-4">Valid From: </div><div class="col-xs-8">' + removeTags(cert.valid_from || "N/A") + "</div></div>";
    chain += '<div class="row left"><b><div class="col-xs-4">Valid To: </div><div class="col-xs-8">' + removeTags(cert.valid_to || "N/A") + "</div></b></div>";
    chain += '<div class="row left"><div class="col-xs-4">Serial No.: </div><div class="col-xs-8">' + removeTags(cert.serialNumber || "N/A") + "</div></div>";
    chain += '<div class="row left"><b><div class="col-xs-4">Issuer: </div><div class="col-xs-8">' + removeTags(cert.issuer.CN || "N/A") + "</div></b></div>";
    chain += "</div></div>";
    root_cert = cert;
    cert = cert.issuerCertificate;
    i++;
  }
  // Warning for incomplete certificate chain
  if (data.self_signed) {
    var alert = '<br><hr/><br><p><strong><div class="alert alert-danger" role="alert"><span class="glyphicon glyphicon-warning-sign" aria-hidden="true"></span> ';
    if (root_cert == data) {
      alert += "This certificate is self signed and may not be trusted by some browsers.";
    } else {
      alert += "The root certificate in this chain is not trusted by some browsers.";
    }
    chain += alert + "</strong></p></div>";
  } else if (!data.chain_of_trust_complete) {
    var alert = '<br><hr/><br><div class="alert alert-danger" role="alert">';
    // If we have the certificate for download, offer the user the link
    if (root_cert.next_cert_id) {
      alert += '<p class="pull-right"><a href="/api/chain?type=crt&id=' + root_cert.next_cert_id + '" class="btn btn-danger">Download the Chain Here</a></p>';
    }
    alert += '<p><strong>Error! The next certificate in the chain is missing.</strong> The next certificate should be: "' + removeTags(root_cert.issuer.CN || "N/A") + '".</p>';
    chain += alert + "</div>";
  }
  $("#cert_chain").html(chain);

  //Insecure Links
  if (!cert_name_match) {
    $("#insecure_links_left").html("");
    $("#insecure_links_left").html('<h4 class="text-center">Links cannot be scanned due to Failed Domain Check</h4>');
    $("#inseclinks").slideDown();
  } else {
    var insecure_links = data.inlinks;
    var insecure_links_count = 0;
    if (data.inlinks) {
      insecure_links_count = data.inlinks.length;
    }
    $("#insecure_links_left").html("");
    if (insecure_links_count > 0) {
      //Insecure Links List
      $("#insecure_links_left").html("<p>");
      for (var i = 0; i < insecure_links_count; i++) {
        $("#insecure_links_left").append("<li>" + insecure_links[i] + "</li>" + "<br>");
      }
      $("#insecure_links_left").append("</p>");
      $("#inseclinks").slideDown();
    } else {
      $("#insecure_links_left").html('<h4 class="text-center">No Insecure Links Found</h4>');
      $("#inseclinks").slideDown();
    }
  }

  //Report Summary

  function add_checklist_item(name, checked, checked_desciption, alt_description) {
    var grade = checked;
    var description = checked ? checked_desciption : alt_description;
    if (grade) {
      $("#installation_summary").append('<div class="row center"><div class="col-md-5"><h3>' + name + '</h3></div><div class="col-md-2"><span style="color:green; font-weight:600; font-size:3em;"><span class="glyphicon glyphicon-ok" aria-hidden="true"></span></span></div><div class="col-md-5 textContainer"><p>' + description + "</p></div></div><hr>");
    } else $("#installation_summary").append('<div class="row center pink-alert"><div class="col-md-5"><h3>' + name + '</h3></div><div class="col-md-2"><span style=" font-weight:600; font-size:3em;"><span class="glyphicon glyphicon-remove" aria-hidden="true"></span></span></div><div class="col-md-5 textContainer"><p>' + description + "</p></div></div><hr>");
  }

  //Installation Summary
  $("#installation_summary").html("");
  var warnings = 0;

  //Name mismatch
  add_checklist_item("Domain Check", cert_name_match, "<b> " + data.url + ' </b>exists in the list of <a id="link_san_entries_section" class="link"><b>SAN entries</b>.<a>', "" + data.url + ' does not exist in the list of <a id="link_san_entries_section" class="link"><b>SAN entries</b>.<a>');

  //Certificate Validity
  var valid_to = new Date(data.valid_to);
  var current_date = new Date();
  var difference_days = (valid_to.getTime() - current_date.getTime()) / (1000 * 60 * 60 * 24);
  add_checklist_item("Certificate Validity", difference_days >= 0, "This certificate will expire in <b>" + Math.floor(difference_days) + " days.</b>", "This certificate expired " + Math.floor(difference_days * -1) + " days ago.");

  //Self Signed
  add_checklist_item("Trusted CA", !data.self_signed, "This Certificate Authority is trusted.", 'This Certificate Authority may not be trusted. Check your <a id="link_cert_chain_section" class="link">certificate chain</a> for more information.');

  //Chain of Trust
  if (!data.self_signed) {
    add_checklist_item("Certificate Chain", data.chain_of_trust_complete, 'This <a id="link_cert_chain_section" class="link"><b>certificate chain</b></a> is complete.', 'This <a id="link_cert_chain_section" class="link"><b>certificate chain</b></a> is incomplete.');
    add_checklist_item("Revocation Status", !data.revoked, "This certificate has not been revoked.", "This certificate has been revoked.");
  }

  $("#installation_summary hr").last().remove(); // Remove horizontal line between last summary item and end of div

  //show report
  $("#report_body").show();
}